/** Commitment types a crew role can carry. A role may list more than one. */
export const COMMITMENT_TYPES = ["contract", "contract_to_hire", "part_time", "full_time"] as const;

export type CommitmentType = (typeof COMMITMENT_TYPES)[number];

const LABELS: Record<string, string> = {
  contract: "Contract",
  contract_to_hire: "Contract-to-Hire",
  part_time: "Part Time",
  full_time: "Full Time",
  // Legacy single values kept readable for older records.
  "part-time": "Part Time",
  volunteer: "Volunteer",
  paid: "Paid",
};

export function commitmentLabel(value: string): string {
  return LABELS[value] ?? "Crew";
}

export function commitmentLabels(values: string[] | null | undefined): string[] {
  if (!values?.length) return [];
  return values.map(commitmentLabel);
}
